// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ballooning-recovery.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ballooning-recovery/ballooning-recovery.js';
import g1 from '../lessons/aeronautics/ballooning-recovery/landing-faults.js';

mount([g0, g1]);
